/**
 * Zod schemas for projection file import validation.
 * Used for client-side header validation before upload.
 */
import { z } from 'zod'

/** Required column headers that must be present in projection import files */
export const REQUIRED_PROJECTION_IMPORT_HEADERS = ['facility', 'category', 'date', 'description', 'amount'] as const

/** All recognized column headers for projection import files */
export const ALL_PROJECTION_IMPORT_HEADERS = [
  'facility',
  'category',
  'date',
  'description',
  'amount',
  'notes',
] as const

/**
 * Schema for validating that required headers are present in a projection import file.
 * Normalizes headers to lowercase and trims whitespace before checking.
 */
export const projectionImportHeadersSchema = z.object({
  headers: z.array(z.string()).refine(
    (headers) => {
      const normalized = headers.map(h => h.trim().toLowerCase())
      return REQUIRED_PROJECTION_IMPORT_HEADERS.every(required => normalized.includes(required))
    },
    {
      message: `Missing required columns. Required: ${REQUIRED_PROJECTION_IMPORT_HEADERS.join(', ')}`,
    },
  ),
})
